module.exports = __webpack_public_path__ + "static/media/Email.7b13b024.svg";